(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  const observer = new IntersectionObserver(entries => {
    let position = 0;
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (reducedMotion.matches || entry.target.matches(':focus-within')) continue;
      const animation = entry.target.animate([
        { opacity: 0, translate: '0 22px' },
        { opacity: 1, translate: '0 0' }
      ], {
        duration: 560,
        delay: Math.min(position++, 3) * 65,
        easing: 'cubic-bezier(.22,.61,.36,1)',
        fill: 'backwards'
      });
      active.add(animation);
      const finish = () => active.delete(animation);
      animation.onfinish = finish;
      animation.oncancel = finish;
    }
  }, { threshold: 0.06 });
  const register = node => {
    if (!(node instanceof Element)) return;
    const cards = node.matches('product-card') ? [node] : node.querySelectorAll('product-card');
    for (const card of cards) {
      if (seen.has(card)) continue;
      seen.add(card);
      observer.observe(card);
    }
  };
  register(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) register(node);
      for (const node of record.removedNodes) {
        if (!(node instanceof Element)) continue;
        const cards = node.matches('product-card') ? [node] : node.querySelectorAll('product-card');
        for (const card of cards) if (!card.isConnected) observer.unobserve(card);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) for (const animation of active) animation.cancel();
  });
  document.addEventListener('focusin', event => {
    const card = event.target.closest('product-card');
    if (card) for (const animation of active) if (animation.effect.target === card) animation.cancel();
  });
})();
